var StageScaleMode = /** @class */ (function () {
    function StageScaleMode() {
    }
    StageScaleMode.EXACT_FIT = 'exactFit';
    StageScaleMode.NO_BORDER = 'noBorder';
    StageScaleMode.NO_SCALE = 'noScale';
    StageScaleMode.SHOW_ALL = 'showAll';
    return StageScaleMode;
}());
export { StageScaleMode };
